import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import CourseClassContext from '../../CourseClassContext'
import CourseClassTeachers from '../CourseClassTeachers'

const CourseClassTeacherTab = () => {
    const {item, renderWarnings = NullAsDefault} = useContext(CourseClassContext)
    const warnings = Array.from(item?.warnings ?? [])

    if (warnings.length) {
        return (
            <div className="w-full flex flex-col gap-3">
                {renderWarnings(warnings)}
            </div>
        )
    }

    return (
        <div className="py-2">
            <CourseClassTeachers item={item}/>
        </div>
    )
}

export default CourseClassTeacherTab
